/**
 * EINE BÜROKLAMMER STATT EINES UMSCHLAGS.
 *
 * ORIGINALTEXT MARVIN (08.09.2026, Punkt 7)
 *   „Postfach: Design, Thumbnails der Anhänge, Anhänge in einem Fenster statt
 *    neuem Tab, Büroklammer statt Mailsymbol am Auftrag, verschobene Popups"
 *
 * EIN UMSCHLAG SAGT „MAIL", EINE KLAMMER SAGT „ES HÄNGT ETWAS DARAN" - und in
 * einer Liste, in der JEDE Zeile eine Mail ist, sagt der Umschlag nichts. Die
 * Klammer steht deshalb dort, wo es wirklich einen Unterschied gibt: an einer
 * Zeile mit Anhängen, und an keiner ohne.
 *
 * GEZEICHNET STATT GELADEN, aus demselben Grund wie die Glocke und das
 * Dateiblatt: ein Symbolzeichen aus einer Schrift sieht auf jedem zweiten
 * Gerät anders aus, und auf manchen ist es ein leeres Kästchen.
 *
 * SIE ERBT DIE FARBE IHRER ZEILE (`currentColor`), und das ist hier richtig:
 * sie steht IN einem Text und nicht in einem Link. Beim Dateiblatt war es
 * genau umgekehrt - dort stand das Sinnbild in einem `<a>` und hat dessen
 * Blau geerbt, und dieselbe Datei sah nach dem ersten Öffnen anders aus als
 * ihre Nachbarin.
 */
export function Klammer({ titel }: { titel?: string }) {
  return (
    <svg className="klammer" viewBox="0 0 24 24" width="13" height="13"
         role="img" aria-label={titel ?? 'Anhang'}>
      {titel && <title>{titel}</title>}
      {/* Ein Bogen, der oben herumgeht und unten wieder heraufkommt. */}
      <path d="M16.5 8.5v7.25a4.25 4.25 0 0 1-8.5 0V7.25a2.75 2.75 0 0 1 5.5
               0v8.25a1.25 1.25 0 0 1-2.5 0V8.5"
            fill="none" stroke="currentColor" strokeWidth="1.8"
            strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
